import id from './id.json';

export default {
    id: id,
};